import React from 'react';
import styled from 'styled-components';
import moment from 'moment';
import DatePicker, { registerLocale, setDefaultLocale } from 'react-datepicker';
import fi from 'date-fns/locale/fi';
import 'react-datepicker/dist/react-datepicker.css';

function _extends() {
  _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends.apply(this, arguments);
}

function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;

  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }

  return target;
}

function _objectWithoutProperties(source, excluded) {
  if (source == null) return {};

  var target = _objectWithoutPropertiesLoose(source, excluded);

  var key, i;

  if (Object.getOwnPropertySymbols) {
    var sourceSymbolKeys = Object.getOwnPropertySymbols(source);

    for (i = 0; i < sourceSymbolKeys.length; i++) {
      key = sourceSymbolKeys[i];
      if (excluded.indexOf(key) >= 0) continue;
      if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
      target[key] = source[key];
    }
  }

  return target;
}

function _taggedTemplateLiteral(strings, raw) {
  if (!raw) {
    raw = strings.slice(0);
  }

  return Object.freeze(Object.defineProperties(strings, {
    raw: {
      value: Object.freeze(raw)
    }
  }));
}

var img$2 = "data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 7.68 13.81'%3e%3cdefs%3e%3cstyle%3e.a%7bfill:none%3bstroke:%23163979%3bstroke-linecap:round%3bstroke-linejoin:round%3b%7d%3c/style%3e%3c/defs%3e%3ctitle%3enuoli_oikealle%3c/title%3e%3cpath class='a' d='M.5%2c13.31%2c7.18%2c6.74.5.5'/%3e%3c/svg%3e";

var img$1 = "data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' xmlns:xlink='http://www.w3.org/1999/xlink' width='24' height='24' viewBox='0 0 24 24'%3e %3cdefs%3e %3cclipPath id='clip-path'%3e %3crect id='Rectangle_1071' data-name='Rectangle 1071' width='24' height='24' transform='translate(-0.032 -0.032)' fill='%23163979'/%3e %3c/clipPath%3e %3c/defs%3e %3cg id='Group_1889' data-name='Group 1889' transform='translate(0.032 0.032)'%3e %3cg id='Group_1888' data-name='Group 1888' clip-path='url(%23clip-path)'%3e %3cpath id='Path_639' data-name='Path 639' d='M0%2c19.5a4.672%2c4.672%2c0%2c0%2c0%2c4.745%2c4.463H19.223a4.658%2c4.658%2c0%2c0%2c0%2c4.744-4.433V7.337a4.793%2c4.793%2c0%2c0%2c0-4.744-5.044H17.662V1.07a1.071%2c1.071%2c0%2c0%2c0-2.143%2c0V2.293H8.448V1.07a1.071%2c1.071%2c0%2c0%2c0-2.143%2c0V2.293H4.745A4.793%2c4.793%2c0%2c0%2c0%2c0%2c7.337ZM2.143%2c9.049V7.031a2.6%2c2.6%2c0%2c0%2c1%2c2.6-2.6H6.306V6.267a1.071%2c1.071%2c0%2c0%2c0%2c2.143%2c0V4.433h7.1V6.267a1.071%2c1.071%2c0%2c0%2c0%2c2.143%2c0V4.433h1.561a2.572%2c2.572%2c0%2c0%2c1%2c2.6%2c2.6V9.355H2.143Zm0%2c2.751v-.306H21.825v7.7a2.552%2c2.552%2c0%2c0%2c1-2.571%2c2.6H4.745a2.573%2c2.573%2c0%2c0%2c1-2.6-2.6Z' fill='%23163979'/%3e %3c/g%3e %3c/g%3e%3c/svg%3e";

var _templateObject$5, _templateObject2, _templateObject3, _templateObject4, _templateObject5, _templateObject6, _templateObject7;
registerLocale('fi', fi);
setDefaultLocale('fi');

var Wrapper = function Wrapper(props) {
  // Change Moment props to vanilla since that's what DatePicker uses
  var selected = props.selected,
      _onChange = props.onChange,
      controls = props.controls,
      onPrevious = props.onPrevious,
      onNext = props.onNext,
      minTime = props.minTime,
      maxTime = props.maxTime,
      width = props.width,
      invalid = props.invalid,
      inheritedProps = _objectWithoutProperties(props, ["selected", "onChange", "controls", "onPrevious", "onNext", "minTime", "maxTime", "width", "invalid"]);

  return /*#__PURE__*/React.createElement(Container$3, {
    width: width,
    controls: controls,
    invalid: invalid
  }, /*#__PURE__*/React.createElement(DatePicker, _extends({
    selected: selected && selected.isValid && selected.isValid() && selected.toDate(),
    onChange: function onChange(date) {
      var mDate = moment(date);

      if (mDate.isValid()) {
        _onChange(moment(date));
      } else {
        console.debug("Entered date '".concat(date, "' is invalid"));
      }
    },
    minTime: minTime ? minTime.toDate() : null,
    maxTime: maxTime ? maxTime.toDate() : null
  }, inheritedProps)), controls && /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(ArrowContainerLeft, {
    onClick: onPrevious
  }, /*#__PURE__*/React.createElement(ArrowLeft, {
    src: img$2
  })), /*#__PURE__*/React.createElement(ArrowContainerRight, {
    onClick: onNext
  }, /*#__PURE__*/React.createElement(ArrowRight, {
    src: img$2
  }))));
};

var Container$3 = styled.div(_templateObject$5 || (_templateObject$5 = _taggedTemplateLiteral(["\n  position: relative;\n\n  input {\n    width: ", ";\n    color: #313131;\n    padding: 8px;\n    padding-left: 15px;\n\n    font-size: 16px;\n    border-radius: 4px;\n    border: 1px solid ", ";\n    line-height: 16px;\n    // prettier-ignore\n    background: white url(\"", "\");\n    background-size: 24px 24px;\n    background-repeat: no-repeat;\n    background-position: right ", "\n      center;\n  }\n"])), function (props) {
  return props.width || '110px';
}, function (props) {
  return props.invalid ? 'red' : '#aeaeae';
}, img$1, function (props) {
  return props.controls ? '30px' : '7px';
});
var ArrowContainer = styled.div(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["\n  position: absolute;\n  top: 3px;\n  height: 34px;\n  width: 30px;\n  border-radius: 4px;\n  cursor: pointer;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n"])));
var ArrowContainerRight = styled(ArrowContainer)(_templateObject3 || (_templateObject3 = _taggedTemplateLiteral(["\n  right: 0;\n"])));
var ArrowContainerLeft = styled(ArrowContainer)(_templateObject4 || (_templateObject4 = _taggedTemplateLiteral(["\n  left: 0;\n"])));
var Arrow = styled.img(_templateObject5 || (_templateObject5 = _taggedTemplateLiteral(["\n  height: 16px;\n"])));
var ArrowLeft = styled(Arrow)(_templateObject6 || (_templateObject6 = _taggedTemplateLiteral(["\n  transform: rotate(180deg);\n"])));
var ArrowRight = styled(Arrow)(_templateObject7 || (_templateObject7 = _taggedTemplateLiteral([""])));

var _templateObject$4;

var DayPicker = function DayPicker(props) {
  var className = props.className,
      inheritedProps = _objectWithoutProperties(props, ["className"]);

  var onPrevious = function onPrevious() {
    return props.onChange(props.selected.subtract(1, 'day').clone());
  };

  var onNext = function onNext() {
    return props.onChange(props.selected.add(1, 'day').clone());
  };

  return /*#__PURE__*/React.createElement(Container$2, {
    className: className,
    controls: props.controls
  }, /*#__PURE__*/React.createElement(Wrapper, _extends({
    dateFormat: "dd.MM.yyyy",
    onPrevious: onPrevious,
    onNext: onNext
  }, inheritedProps)));
};

var Container$2 = styled.div(_templateObject$4 || (_templateObject$4 = _taggedTemplateLiteral(["\n  .react-datepicker-popper {\n    min-width: 250px;\n  }\n\n  input {\n    & {\n      width: ", ";\n      padding-left: ", ";\n      padding-right: 30px;\n      // text-align: center;\n    }\n  }\n"])), function (p) {
  return p.controls ? '180px' : '145px';
}, function (p) {
  return p.controls ? '30px' : '15px';
});

var img = "data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' xmlns:xlink='http://www.w3.org/1999/xlink' width='24' height='24' viewBox='0 0 24 24'%3e %3cdefs%3e %3cclipPath id='clip-path'%3e %3crect id='Rectangle_1072' data-name='Rectangle 1072' width='24' height='24' fill='%23163979'/%3e %3c/clipPath%3e %3c/defs%3e %3cg id='Group_1891' data-name='Group 1891' transform='translate(0.053 0.053)'%3e %3cg id='Group_1890' data-name='Group 1890' transform='translate(-0.053 -0.053)' clip-path='url(%23clip-path)'%3e %3cpath id='Path_640' data-name='Path 640' d='M38.659%2c23.265l-.089-.089V17.712a1.1%2c1.1%2c0%2c0%2c0-1.062-1.062%2c1.05%2c1.05%2c0%2c0%2c0-1.062%2c1.062v5.915a1.1%2c1.1%2c0%2c0%2c0%2c.305.756L40.271%2c27.9a1.069%2c1.069%2c0%2c0%2c0%2c1.512-1.512Z' transform='translate(-25.509 -11.626)' fill='%23163979'/%3e %3cpath id='Path_641' data-name='Path 641' d='M11.951%2c0A11.951%2c11.951%2c0%2c1%2c0%2c23.9%2c11.951%2c11.964%2c11.964%2c0%2c0%2c0%2c11.951%2c0m0%2c21.748a9.839%2c9.839%2c0%2c0%2c1-9.828-9.828A9.686%2c9.686%2c0%2c0%2c1%2c4.96%2c4.989a9.835%2c9.835%2c0%2c1%2c1%2c6.991%2c16.759' transform='translate(0.049 0.049)' fill='%23163979'/%3e %3c/g%3e %3c/g%3e%3c/svg%3e";

var _templateObject$3;

var TimePicker = function TimePicker(props) {
  return /*#__PURE__*/React.createElement(StyledDayPicker$1, _extends({
    dateFormat: "dd.MM.yyyy 'klo' H.mm",
    timeCaption: "Aika"
  }, props, {
    showTimeSelect: true
  }));
};

var StyledDayPicker$1 = styled(DayPicker)(_templateObject$3 || (_templateObject$3 = _taggedTemplateLiteral(["\n  .react-datepicker-popper {\n    min-width: 350px;\n  }\n\n  input {\n    & {\n      width: ", ";\n      padding-left: 15px;\n\n      // text-align: center;\n      // We need the \" instead of ' so disable prettier for this\n      // prettier-ignore\n      background: white url(\"", "\");\n      background-size: 24px 24px;\n      background-repeat: no-repeat;\n      background-position: right 7px center;\n    }\n  }\n"])), function (props) {
  return props.width || '210px';
}, img);

var _templateObject$2;

var MonthPicker = function MonthPicker(props) {
  var inheritedProps = _extends({}, props); // Add some handlers. Clone is required because otherwise the same reference
  // is kept


  var onPrevious = function onPrevious() {
    return props.onChange(props.selected.subtract(1, 'month').clone());
  };

  var onNext = function onNext() {
    return props.onChange(props.selected.add(1, 'month').clone());
  };

  return /*#__PURE__*/React.createElement(Container$1, {
    controls: props.controls
  }, /*#__PURE__*/React.createElement(Wrapper, _extends({
    dateFormat: "MMM yyyy",
    showMonthYearPicker: true,
    onPrevious: onPrevious,
    onNext: onNext
  }, inheritedProps)));
};

var Container$1 = styled.div(_templateObject$2 || (_templateObject$2 = _taggedTemplateLiteral(["\n  .react-datepicker-popper {\n    min-width: 250px;\n  }\n\n  input {\n    & {\n      padding-right: 30px;\n      width: ", ";\n      padding-left: ", ";\n    }\n  }\n\n  // By default MMMM date format is 'tammikuuta', so we use 'tammi'\n  // and modify it to 'tammikuu'\n  .react-datepicker__month-text {\n    // text-transform: capitalize;\n\n    &::after {\n      // content: 'kuu';\n    }\n  }\n"])), function (p) {
  return p.controls ? '190px' : '140px';
}, function (p) {
  return p.controls ? '30px' : '15px';
});

var _templateObject$1;

var YearPicker = function YearPicker(props) {
  var inheritedProps = _extends({}, props); // Add some handlers. Clone is required because otherwise the same reference
  // is kept


  var onPrevious = function onPrevious() {
    return props.onChange(props.selected.subtract(1, 'year').clone());
  };

  var onNext = function onNext() {
    return props.onChange(props.selected.add(1, 'year').clone());
  };

  return /*#__PURE__*/React.createElement(Container, {
    controls: props.controls
  }, /*#__PURE__*/React.createElement(Wrapper, _extends({
    dateFormat: "yyyy",
    showYearPicker: true,
    onPrevious: onPrevious,
    onNext: onNext
  }, inheritedProps)));
};

var Container = styled.div(_templateObject$1 || (_templateObject$1 = _taggedTemplateLiteral(["\n  .react-datepicker-popper {\n    min-width: 250px;\n  }\n\n  input {\n    & {\n      padding-right: 30px;\n      width: ", ";\n      padding-left: ", ";\n    }\n  }\n"])), function (p) {
  return p.controls ? '135px' : '85px';
}, function (p) {
  return p.controls ? '30px' : '10px';
});

var _templateObject;

var HourPicker = function HourPicker(props) {
  return /*#__PURE__*/React.createElement(StyledDayPicker, _extends({
    showTimeSelect: true,
    showTimeSelectOnly: true,
    dateFormat: "HH.mm"
  }, props));
};

var StyledDayPicker = styled(DayPicker)(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  .react-datepicker-popper {\n    min-width: 150px;\n  }\n\n  input {\n    & {\n      width: ", ";\n      padding-left: ", ";\n\n      // text-align: center;\n      // We need the \" instead of ' so disable prettier for this\n      // prettier-ignore\n      background: white url(\"", "\");\n      background-size: 24px 24px;\n      background-repeat: no-repeat;\n      background-position: right ", "\n        center;\n    }\n  }\n"])), function (p) {
  return p.controls ? '140px' : '100px';
}, function (p) {
  return p.controls ? '30px' : '15px';
}, img, function (props) {
  return props.controls ? '30px' : '7px';
});

export { Wrapper as DatePicker, DayPicker, HourPicker, MonthPicker, TimePicker, YearPicker };
